<script>
export default {
    name: 'SideMenu',
    props: {
        groups: {
            type: Array,
            required: true,
        },
    },
}
</script>

<template>
    <nav class="side-menu">
        <div v-for="(group, gi) in groups" :key="gi" class="side-menu__group">
            <div v-if="group.label" class="side-menu__head" :class="{ [`side-menu__head--${group.accent}`]: group.accent }">
                <b-icon v-if="group.icon" :icon="group.icon" class="mr-1" />{{ group.label }}
            </div>
            <template v-for="item in group.items">
                <router-link v-if="item.to" :key="item.key" :to="item.to" :exact="!!item.exact" class="side-menu__item" :class="{ [`side-menu__item--${item.accent}`]: item.accent }">
                    <b-icon v-if="item.icon" :icon="item.icon" class="side-menu__icon" />
                    <span class="side-menu__label">{{ item.label }}</span>
                </router-link>
                <button
                    v-else
                    :key="item.key"
                    type="button"
                    class="side-menu__item"
                    :class="{ 'is-active': item.active, [`side-menu__item--${item.accent}`]: item.accent }"
                    @click="$emit('select', item)"
                >
                    <b-icon v-if="item.icon" :icon="item.icon" class="side-menu__icon" />
                    <span class="side-menu__label">{{ item.label }}</span>
                </button>
            </template>
        </div>
    </nav>
</template>

<style lang="scss" scoped>
.side-menu {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--line);
    border-radius: var(--r-lg);
    background: var(--panel);
    overflow: hidden;
}
.side-menu__group + .side-menu__group {
    border-top: 1px solid var(--line);
}
.side-menu__head {
    padding: 12px 18px;
    background: var(--panel-2);
    border-bottom: 1px solid var(--line);
    font-family: var(--font-display);
    font-weight: 600;
    font-size: 11px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--muted);
}
.side-menu__head--gold {
    background: color-mix(in srgb, var(--sos-gold) 16%, var(--panel-2));
    color: color-mix(in srgb, var(--sos-gold) 70%, var(--muted));
}
.side-menu__item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    text-align: left;
    border: 0;
    border-bottom: 1px solid var(--line);
    border-left: 3px solid transparent;
    background: transparent;
    padding: 12px 18px;
    font-family: var(--font-display);
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--muted);
    cursor: pointer;
    white-space: nowrap;

    &:last-child {
        border-bottom: 0;
    }
    &:hover,
    &:focus {
        color: var(--ink);
        background: var(--action-soft);
        text-decoration: none;
    }
    &.is-active,
    &.router-link-active {
        color: var(--action);
        border-left-color: var(--action);
        background: var(--action-soft);
    }
}
.side-menu__item--gold {
    color: color-mix(in srgb, var(--sos-gold) 65%, var(--muted));

    .side-menu__icon {
        color: var(--sos-gold);
        opacity: 1;
    }
    &.is-active,
    &.router-link-active {
        color: var(--black);
        border-left-color: var(--sos-gold);
        background: var(--sos-gold);

        .side-menu__icon {
            color: var(--black);
        }
    }
}
.side-menu__icon {
    flex: none;
    opacity: 0.8;
}

@media (max-width: 991px) {
    .side-menu {
        flex-direction: row;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
    }
    .side-menu::-webkit-scrollbar {
        display: none;
    }
    .side-menu__group {
        display: flex;
    }
    .side-menu__group + .side-menu__group {
        border-top: 0;
        border-left: 1px solid var(--line);
    }
    .side-menu__head {
        display: none;
    }
    .side-menu__item {
        width: auto;
        border-bottom: 0;
        border-left: 0;
        border-top: 2px solid transparent;

        &.is-active,
        &.router-link-active {
            border-left: 0;
            border-top-color: var(--action);
        }
        &.side-menu__item--gold.is-active,
        &.side-menu__item--gold.router-link-active {
            border-top-color: var(--sos-gold);
        }
    }
}
</style>
